module.exports = __webpack_public_path__ + "img/tra_bg_pro@2x.feec5b6f.png";